import React from 'react';
import styled from 'styled-components';

import {
  Button
} from './Button';

export const GreenButton = styled((props) => <Button {...props} />).attrs(
  (props) => ({
    automationid:
      props.automationid ||
      `SalesLead_button_${ props?.automationidattr?.replace(/ /g, '') }_1"`
  })
)`
  border: none;
  color: white;
  background: #428600;
  border-radius: ${ (props) => props.borderRadius };
  &:hover {
    background: #307400;
  }
  &:disabled {
    background: #ebebeb;
    color: #cccccc;
    border: none;
  }
`;
